import { gsap } from "gsap";
import { lerp, getMousePos, getSiblings } from "../utils/utils";

/**
 * Documentation
 *

To add interaction to an item, add a data attribute of data-cursor="{type}".

Use the type to define what cursor it is.

data-cursor can be either 'view', 'play' or 'drag'

/**
 * 
 */

let mouse = { x: 0, y: 0 };

window.addEventListener("mousemove", (ev) => {
	mouse = getMousePos(ev);
});

export default class Cursor {
	constructor() {

		this.Cursor 				= document.querySelector(".cursors");
		this.Cursor.style.opacity 	= 0;
		this.hoverItems 			= document.querySelectorAll('[data-cursor]');
		this.scaleAnimation			= []
		this.rotateAnimation 		= []
		this.cursorConfigs = {
			x: { previous: 0, current: 0, amt: 0.2 },
			y: { previous: 0, current: 0, amt: 0.2 },
		};


		// Create animation timeline
		gsap.set( this.Cursor, {
			opacity: 0,
			scale: 0
		})

		gsap.set( this.Cursor.querySelector(".cursor--view"), {
			scale: 0
		})
		gsap.set( this.Cursor.querySelector(".cursor--drag"), {
			scale: 0
		})
		gsap.set( this.Cursor.querySelector(".cursor--book"), {
			scale: 0
		})

		this.scaleAnimation['view'] = gsap.timeline()
		.to( this.Cursor.querySelector(".cursor--view"), {
			duration: 0.3,
			scale: 1,
			ease: "Power3.easeOut",
		}).paused(true)

		this.scaleAnimation['drag'] = gsap.timeline()
		.to( this.Cursor.querySelector(".cursor--drag"), {
			duration: 0.3,
			scale: 1,
			ease: "Power3.easeOut",
		}).paused(true)

		this.scaleAnimation['book'] = gsap.timeline()
		.to( this.Cursor.querySelector(".cursor--book"), {
			duration: 0.3,
			scale: 1,
			ease: "Power3.easeOut",
		}).paused(true)


		// Watch all hover items for mouse interactions
		this.hoverItems.forEach((hoverItem,index) => {

			let cursorType = this.Cursor.querySelector(`.cursor--${hoverItem.dataset.cursor}`)

			hoverItem.style.cursor = "none";

			this.rotateAnimation[index] = gsap.timeline()
			.to( cursorType.querySelector('.cursor__ring'), {
				duration: 10,
				rotate: 360,
				ease: 'none',
				repeat: -1
			}).paused(true)

			hoverItem.addEventListener("mouseenter", () => {

				let isNull = hoverItem.getAttribute('data-cursor-null');

				if (isNull)
				{
					return
				} else 
				{
					this.scaleAnimation[`${hoverItem.dataset.cursor}`].play()
					this.rotateAnimation[index].play()
				}
				
			});

			hoverItem.addEventListener("mouseleave", () => {
				this.scaleAnimation[`${hoverItem.dataset.cursor}`].reverse(1)
				this.rotateAnimation[index].pause()
			});
		});


		// Define mouse move function
		this.onMouseMoveEv = () => {
			this.cursorConfigs.x.previous = this.cursorConfigs.x.current = mouse.x;
			this.cursorConfigs.y.previous = this.cursorConfigs.y.current = mouse.y;
			gsap.to(this.Cursor, {
				duration: '300ms',
				ease: "Power3.easeOut",
				opacity: 1,
			});

			requestAnimationFrame(() => {
				this.render();
			});

			window.removeEventListener("mousemove", this.onMouseMoveEv);
		};

		// assign mouse move function
		window.addEventListener("mousemove", this.onMouseMoveEv);
	}

	render() {
		this.cursorConfigs.x.current = mouse.x;
		this.cursorConfigs.y.current = mouse.y;

		// lerp
		for (const key in this.cursorConfigs) {
			this.cursorConfigs[key].previous = lerp(
				this.cursorConfigs[key].previous,
				this.cursorConfigs[key].current,
				this.cursorConfigs[key].amt
			);
		}

		if(this.CursorMedia){
			let mediaHeight = this.Cursor.querySelector(".cursor-media").offsetHeight;
			if (mouse.y < mediaHeight) {
				this.Cursor.classList.add("top");
			} else {
				this.Cursor.classList.remove("top");
			}
		}
		
		//	set cursor x and y to cursor html element
		this.Cursor.style.transform = `translateX(${this.cursorConfigs.x.previous}px) translateY(${this.cursorConfigs.y.previous}px)`;

		// loop
		requestAnimationFrame(() => this.render());
	}

}
